function setFavoritesEmptyState(){
    const videosNumber = favoritesVideosData.length;
    const eventsNumber = favoritesEventsData.length;
    const trainingsNumber = favoritesTrainingData.length;
    const mountainsNumber = favoritesMountainsData.length;
    const teamsNumber = favoritesTeamsData.length;

    const allCardsContainer = $('.js-favorites-cards-all-container');
    const totalEmptyStateContainer = $('.js-favorites-empty-container');

    const itemsLength = [videosNumber, eventsNumber, trainingsNumber, mountainsNumber, teamsNumber];

    itemsLength.map((item, i) => {
        const emptyContainer = $('.js-tab-section').eq(i).find(`.js-favorites-empty-section-container`);
            item > 0
            ? emptyContainer.removeClass('active')
            : emptyContainer.addClass('active')
        }
    );

    if(!itemsLength.some(value => value > 0)){
        allCardsContainer.removeClass('active');
        totalEmptyStateContainer.addClass('active');
    } else {
        allCardsContainer.addClass('active');
        totalEmptyStateContainer.removeClass('active');
    }
}

runIfElementExist(setFavoritesEmptyState, '.js-favorites-cards-all-container');
